import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AppBar from "components/appBar/AppBar";
import AppDrawer from "components/appDrawer/AppDrawer";
import useBase from "hooks/useBase";
import useWindowSize from "hooks/useWindowSize";
import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

const AdminLayout = () => {
  const {
    base: { featureLists = [] },
  } = useBase();
  const location = useLocation();
  const { isMini } = useWindowSize();
  const isDashboardPath = location.pathname === "/";
  const [toggleNavbar, setToogleNavbar] = useState(false);
  const { pathname } = useLocation();
  const paths = pathname?.split("/");
  const firstPath = paths[1];
  const lastPath = paths[paths.length - 1];

  return (
    <Grid container>
      <AppDrawer
        isDashboardPath={isDashboardPath}
        toggleNavbar={toggleNavbar}
        setToogleNavbar={setToogleNavbar}
      />
      <Box
        sx={{
          width:
            toggleNavbar || isMini ? "calc(100% - 0px)" : "calc(100% - 250px)",
          transition: isDashboardPath ? "unset" : "all 0.5s ease",
          marginLeft: toggleNavbar || isMini ? 0 : "250px",
        }}
      >
        <AppBar
          toggleNavbar={toggleNavbar}
          setToogleNavbar={setToogleNavbar}
          isDashboardPath={isDashboardPath}
        />
        <Box
          className="layout"
          sx={{
            height: "calc(100vh - 65px)",
            overflowX: "hidden",
            overflowY: "auto",
            bgcolor: "#F9F9F9",
          }}
          onClick={() => isMini && setToogleNavbar(true)}
        >
          {firstPath === "setup" ||
          featureLists?.includes(lastPath || "dashboard") ? (
            <Outlet />
          ) : (
            <p></p>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default AdminLayout;
